import { useEffect, useMemo, useState } from "react";
import AxiosInstance, { IMAGE_BASE_URL, TokenService } from "../../../../services/Api";
import CustomMRTTable from "../../../../components/CustomMRTTable/CustomMRTTable";
import styles from "../index.module.css";
import { useNavigate } from "react-router-dom";
import { FaSchool, FaEye } from "react-icons/fa";
import { useSelector } from "react-redux";
import { CustomButton } from "../../../../components";
const SchoolClassList = () => {
  const user = TokenService.getUser();
  const clientData = user?.client_data[0] || {};
  const school_id = clientData?.school_id || "";
  const academic_year = clientData?.academic_year || "";

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0);

  const [searchInput, setSearchInput] = useState("");
  const [apiSearch, setApiSearch] = useState("");

  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [selectedId, setSelectedId] = useState(null);

  const [rows, setRows] = useState([]);
  const navigate = useNavigate();


  // ================= API CALL =================
  useEffect(() => {
    const fetchHallOfFame = async () => {
      setLoading(true);

      try {
        const response = await AxiosInstance.post("/school/classList", {
          id: school_id,
          academic_year: academic_year
        });
        const apiData = response.data.data || [];

        // Transform API data to match table structure
        const transformedData = apiData
          .filter((item) => item.domain_id !== "CLASS")
          .map((item) => ({
            id: item.id,
            class_id: item.class_id,
            class: item.domain_id,
            maleCount: item.no_of_boys || 0,
            femaleCount: item.no_of_girls || 0,
            totalStudents: (item.no_of_boys || 0) + (item.no_of_girls || 0),
            noOfSection: item.no_of_section || 0,
          }));

        setData(transformedData);
        setRowCount(transformedData.length);

      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchHallOfFame();
  }, [pagination.pageIndex, pagination.pageSize, apiSearch]);

  const { language, translations } = useSelector((state) => state.language);
  const handleView = (student) => {
    navigate(`/user/syllabusList`, {
      state: { CLASSID: student.class_id, studentData: student, mode: "view" },
    });
  };
  // ================= COLUMNS =================
  const columns = useMemo(() => [
    {
      accessorKey: "class",
      header: translations.labels.class,
      muiFilterTextFieldProps: {
        placeholder: "Filter by Class",
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            setApiSearch(e.target.value);
            setPagination((prev) => ({ ...prev, pageIndex: 0 }));
          }
        },
      },
    },
    {
      accessorKey: "noOfSection",
      header: translations.labels.noOfSection,
      muiFilterTextFieldProps: {
        placeholder: "Filter by Content",
        onKeyDown: (e) => {
          if (e.key === "Enter") {
            setApiSearch(e.target.value);
            setPagination((prev) => ({ ...prev, pageIndex: 0 }));
          }
        },
      },
    },
    {
      id: "actions",
      header: translations.labels?.actions || "Actions",
      enableSorting: false,
      enableColumnFilter: false,
      size: 80,
      Cell: ({ row }) => (
        <button
          className={styles.viewBtn}
          onClick={() => handleView(row.original)}
          title={translations.labels?.viewStudent || "View Student"}
        >
          <FaEye />
        </button>
      ),
    },
  ], [selectedId]);

  return (
    <>
      <div className={styles.container}>


        <div className={styles.topBar}>
          <div className={styles.header}>
            <div className={styles.headerIcon}>
              <FaSchool />
            </div>
            <h1 className={styles.headerTitle}>Class List</h1>
          </div>

        </div>
        <CustomMRTTable
          columns={columns}
          data={data}
          loading={loading}
          pagination={pagination}
          rowCount={rowCount}
          onPaginationChange={setPagination}
          searchInput={searchInput}
          setSearchInput={setSearchInput}
          onSearchEnter={(value) => {
            setApiSearch(value);
            setPagination((prev) => ({ ...prev, pageIndex: 0 }));
          }}
          enableSearch={false}
          enableFiltering={false}
        />
      </div>
    </>

  );
};

export default SchoolClassList;


